export const translations = {
  ja: {
    seo: {
      title: "Code Bridge - 日本向けベトナムオフショア開発チーム | ITアウトソーシング",
      description: "Code Bridgeは日本企業向けのベトナムオフショア開発チームです。高品質でコストパフォーマンスの高いITアウトソーシングサービスを提供しています。"
    },
    nav: {
      home: "ホーム",
      services: "サービス",
      about: "会社概要",
      portfolio: "実績",
      news: "ニュース",
      contact: "お問い合わせ",
      languageBtn: "日本語",
    },
    hero: {
      titleLine1: "日本企業向け",
      titleLine2: "ベトナムオフショア開発チーム",
      descLine1: "高品質でコストパフォーマンスに優れたITアウトソーシングサービスを提供。専任チームによる開発から、プロジェクト単位の請負まで、",
      descLine2: "お客様のビジネス成長をサポートします。",
      contactBtn: "お問い合わせはこちら"
    },
    services: {
      sectionTitle: "サービス",
      software: {
        title: "ソフトウェア開発",
        desc: "最新技術を活用したカスタムソフトウェアの設計・開発を行います。"
      },
      mobile: {
        title: "モバイルアプリ開発",
        desc: "iOS・Android対応のモバイルアプリケーション開発サービス。"
      },
      cloud: {
        title: "クラウドソリューション",
        desc: "AWS、Azure、GCPを活用したクラウドインフラ構築。"
      },
      database: {
        title: "データベース設計",
        desc: "効率的なデータベース設計と最適化サービス。"
      }
    },
    portfolio: {
      sectionTitle: "製品",
      country: "Country",
      client: "Client",
      domain: "Domain",
      service: "Service",
      collaboration: "Collaboration Model",
      moreInfo: "More Information"
    },
    company: {
      title: "ビジョンー & ミッション",
      p1: "私たちは、お客様のビジネスニーズを深く理解し、\n最適なソリューションを提供することを使命としています。",
      p2: "豊富な経験と最新の技術力を活かし、お客様の競争力向上に貢献します。\n品質の高いサービスと継続的なサポートで、\n長期的なパートナーシップを築いていきます。"
    },
    advantages: {
      sectionTitle: "私たちのドメイン",
      banking: "銀行業",
      logistics: "物流",
      telecom: "通信",
      insurance: "保険",
      finance: "金融",
      medical: "医療",
      education: "教育",
      ecommerce: "電子商取引"
    },
    leadership: {
      sectionTitle: "創業者とリーダー",
      haiPos: "最高経営責任者",
      haiDesc: "10年以上のソフトウェア開発経験を持つエンジニア",
      chienPos: "最高プロダクト責任者",
      chienDesc: "プロダクト戦略とユーザーエクスペリエンスの専門家",
      thanhPos: "最高技術責任者",
      thanhDesc: "大規模システム設計とアーキテクチャの第一人者"
    },
    partners: {
      sectionTitle: "関連会社パートナー",
      technology: "Technology Partner",
      development: "Development Partner",
      business: "Business Partner",
      innovation: "Innovation Partner",
      creative: "Creative Partner",
      infrastructure: "Infrastructure Partner"
    },
    news: {
      sectionTitle: "ニュース",
      readMore: "続きを読む →",
      items: [
        {
          title: "2025年度新卒採用開始",
          desc: "来年度の新卒採用を開始いたします。エンジニア職を中心に優秀な人材を募集しています。より良いサービス提供のため、チーム拡大を図っています。",
          imageText: "チームミーティング",
          date: "2026年01月31日"
        },
        {
          title: "新オフィス移転のお知らせ",
          desc: "事業拡大に伴い、より広いオフィスに移転いたします。アクセスも向上し、より良い環境でサービスを提供します。最新の設備を導入し、働きやすい環境を整備いたします。",
          imageText: "オフィス風景",
          date: "2025年12月15日"
        }
      ]
    },
    contact: {
      sectionTitle: "お問い合わせ",
      desc1: "プロジェクトのご相談やお見積もりなど、お気軽にお問い合わせください。",
      desc2: "専門スタッフが丁寧に対応させていただきます。",
      formTitle: "お問い合わせフォーム",
      name: "お名前 *",
      email: "メールアドレス *",
      company: "会社名",
      message: "お問い合わせ内容 *",
      submit: "送信",
      submitting: "送信中...",
      errName: "お名前を入力してください。",
      errEmail: "メールアドレスを入力してください。",
      errEmailInvalid: "有効なメールアドレスを入力してください。",
      errMessage: "お問い合わせ内容を入力してください。",
      successMsg: "お問い合わせありがとうございます。メールを送信しました。",
      failMsg: "送信に失敗しました。もう一度お試しください。",
      failReason: "送信エラー: "
    },
    footer: {
      desc1: "日本市場向けのベトナムフリーランス開発チームとして、柔軟で高品質なITソリューションを提供。",
      desc2: "プロジェクト単位から長期契約まで、お客様のニーズに合わせたサービスを提供します。",
      address: "308号室、3階、オフィスビル、Vinhomes West Point、Do Duc Duc通り、Tu Liem区、ハノイ",
      corporate: "企業情報",
      about: "会社について",
      servicesBtn: "サービス",
      portfolioBtn: "実績",
      newsBtn: "ニュース",
      servicesMenu: "サービス",
      software: "ソフトウェア開発",
      mobile: "モバイルアプリ開発",
      cloud: "クラウドソリューション",
      database: "データベース設計",
      products: "製品",
      ecsite: "ECサイト開発",
      bizsys: "業務システム",
      mobileApp: "モバイルアプリ",
      resources: "リソース",
      blog: "ブログ",
      docs: "ドキュメント",
      support: "サポート",
      copyright: "© 2025 Code Bridge. All rights reserved."
    }
  },
  vi: {
    seo: {
      title: "Code Bridge - Đội ngũ phát triển phần mềm cho thị trường Nhật Bản",
      description: "Code Bridge cung cấp dịch vụ gia công phần mềm chất lượng cao tại Việt Nam. Xây dựng dịch vụ CNTT với chi phí tối ưu."
    },
    nav: {
      home: "Trang chủ",
      services: "Dịch vụ",
      about: "Về chúng tôi",
      portfolio: "Dự án",
      news: "Tin tức",
      contact: "Liên hệ",
      languageBtn: "Tiếng Việt",
    },
    hero: {
      titleLine1: "Đội ngũ phát triển phần mềm",
      titleLine2: "tại Việt Nam",
      descLine1: "Cung cấp dịch vụ gia công phần mềm chất lượng cao với chi phí tối ưu. Từ việc xây dựng đội ngũ chuyên biệt đến nhận khoán dự án,",
      descLine2: "chúng tôi luôn đồng hành cùng sự phát triển của bạn.",
      contactBtn: "Liên hệ ngay"
    },
    services: {
      sectionTitle: "Dịch vụ",
      software: {
        title: "Phát triển phần mềm",
        desc: "Thiết kế và phát triển tính năng phần mềm tùy chỉnh công nghệ mới nhất."
      },
      mobile: {
        title: "Ứng dụng di động",
        desc: "Dịch vụ phát triển ứng dụng di động cho cả iOS và Android."
      },
      cloud: {
        title: "Giải pháp đám mây",
        desc: "Xây dựng hạ tầng đám mây với AWS, Azure, GCP."
      },
      database: {
        title: "Thiết kế Data",
        desc: "Thiết kế và tối ưu hóa hệ dữ liệu hiệu quả."
      }
    },
    portfolio: {
      sectionTitle: "Dự án đã làm",
      country: "Quốc gia",
      client: "Khách hàng",
      domain: "Lĩnh vực",
      service: "Dịch vụ",
      collaboration: "Mô hình hợp tác",
      moreInfo: "Xem thông tin chi tiết"
    },
    company: {
      title: "Tầm nhìn & Sứ mệnh",
      p1: "Sứ mệnh của chúng tôi là thấu hiểu sâu sắc nhu cầu kinh doanh của khách hàng và\ncung cấp các giải pháp tối ưu nhất.",
      p2: "Sử dụng kinh nghiệm phong phú và năng lực công nghệ theo kịp xu hướng mới nhất, chúng tôi góp phần nâng cao năng lực cạnh tranh của quý khách.\nThông qua chất lượng dịch vụ dẫn đầu và sự hỗ trợ liên tục,\nchúng tôi thiết lập nên mối quan hệ đối tác bền vững và lâu dài."
    },
    advantages: {
      sectionTitle: "Lĩnh vực chuyên môn",
      banking: "Ngân hàng",
      logistics: "Giao nhận & Vận tải",
      telecom: "Viễn thông",
      insurance: "Bảo hiểm",
      finance: "Tài chính",
      medical: "Y tế & Sức khỏe",
      education: "Giáo dục",
      ecommerce: "Thương mại điện tử"
    },
    leadership: {
      sectionTitle: "Đội ngũ Lãnh đạo",
      haiPos: "Giám đốc Điều hành (CEO)",
      haiDesc: "Kỹ sư với hơn 10 năm kinh nghiệm trong lĩnh vực phát triển phần mềm",
      chienPos: "Giám đốc Sản phẩm (CPO)",
      chienDesc: "Chuyên gia về chiến lược sản phẩm và trải nghiệm người dùng",
      thanhPos: "Giám đốc Công nghệ (CTO)",
      thanhDesc: "Chuyên gia về thiết kế hệ thống và kiến trúc quy mô lớn"
    },
    partners: {
      sectionTitle: "Đối tác liên kết",
      technology: "Đối tác Công nghệ",
      development: "Đối tác Phát triển",
      business: "Đối tác Kinh doanh",
      innovation: "Đối tác Đổi mới",
      creative: "Đối tác Sáng tạo",
      infrastructure: "Đối tác Hạ tầng"
    },
    news: {
      sectionTitle: "Tin tức",
      readMore: "Đọc thêm →",
      items: [
        {
          title: "Tuyển dụng nhân sự cho năm 2025",
          desc: "Chúng tôi bắt đầu tuyển dụng cho năm tài chính tới. Đang tìm kiếm những nhân tài xuất sắc, đặc biệt là kỹ sư. Mục tiêu mở rộng đội ngũ để cung cấp dịch vụ tốt hơn.",
          imageText: "Họp nhóm",
          date: "Ngày 31 tháng 01 năm 2026"
        },
        {
          title: "Thông báo chuyển văn phòng mới",
          desc: "Cùng với việc mở rộng kinh doanh, chúng tôi chuyển đến một văn phòng rộng lớn hơn. Điều kiện đi lại thuận tiện hơn, trang bị cơ sở vật chất hiện đại nhằm mang lại môi trường làm việc tốt nhất.",
          imageText: "Văn phòng",
          date: "Ngày 15 tháng 12 năm 2025"
        }
      ]
    },
    contact: {
      sectionTitle: "Liên hệ",
      desc1: "Vui lòng liên hệ với chúng tôi nếu bạn có bất kỳ thắc mắc nào về dự án hay cần tư vấn giải pháp.",
      desc2: "Đội ngũ chuyên gia của chúng tôi sẽ hỗ trợ bạn một cách tốt nhất.",
      formTitle: "Mẫu liên hệ",
      name: "Họ và tên *",
      email: "Email *",
      company: "Tên công ty",
      message: "Nội dung liên hệ *",
      submit: "Gửi",
      submitting: "Đang gửi...",
      errName: "Vui lòng nhập họ tên.",
      errEmail: "Vui lòng nhập email.",
      errEmailInvalid: "Vui lòng nhập địa chỉ email hợp lệ.",
      errMessage: "Vui lòng nhập nội dung liên hệ.",
      successMsg: "Cảm ơn bạn đã liên hệ. Tin nhắn đã được gửi thành công.",
      failMsg: "Gửi thất bại. Vui lòng thử lại sau.",
      failReason: "Lỗi gửi: "
    },
    footer: {
      desc1: "Là đội ngũ phát triển uy tín tại Việt Nam hướng tới thị trường Nhật Bản, cung cấp các giải pháp CNTT linh hoạt và chất lượng cao.",
      desc2: "Từ các dự án đơn lẻ đến các hợp đồng dài hạn, chúng tôi mang tới dịch vụ đáp ứng mọi nhu cầu của khách hàng.",
      address: "Phòng 308, Tầng 3, Toà nhà Văn phòng, Vinhomes West Point, Đường Đỗ Đức Dục, Phường Mễ Trì, Quận Nam Từ Liêm, Hà Nội",
      corporate: "Về chúng tôi",
      about: "Giới thiệu công ty",
      servicesBtn: "Dịch vụ",
      portfolioBtn: "Dự án đã làm",
      newsBtn: "Tin tức",
      servicesMenu: "Dịch vụ",
      software: "Phát triển phần mềm",
      mobile: "Phát triển ứng dụng di động",
      cloud: "Giải pháp đám mây",
      database: "Thiết kế Database",
      products: "Sản phẩm",
      ecsite: "Phát triển trang web thương mại",
      bizsys: "Hệ thống nghiệp vụ",
      mobileApp: "Ứng dụng Mobile",
      resources: "Tài nguyên",
      blog: "Blog",
      docs: "Tài liệu",
      support: "Hỗ trợ",
      copyright: "© 2025 Code Bridge. All rights reserved."
    }
  }
};
